module.exports = __webpack_public_path__ + "img/murray-the-mummy-and-his-curse.b2c62cf6.jpg";